import rp721 from "./rp721";
import rp722 from "./rp722";
import rp723 from "./rp723";
import rp724 from "./rp724";
import rp725 from "./rp725";
import rp726 from "./rp726";
import rp727 from "./rp727";
import rp728 from "./rp728";
import rp729 from "./rp729";
import rp730 from "./rp730";
import rp731 from "./rp731";
import rp732 from "./rp732";
import rp733 from "./rp733";
import rp734 from "./rp734";
import rp735 from "./rp735";
import rp736 from "./rp736";
import rp737 from "./rp737";
import rp740 from "./rp740";
import rp750 from "./rp750";
import rp787 from "./rp787";
import rp788 from "./rp788";
import rp790 from "./rp790";
import rp720 from "./rp720";

export default {
  rp720,
    rp721,
    rp722,
  rp723,
  rp724,
  rp725,
  rp726,
  rp727,
  rp728,
  rp729,
  rp730,
  rp731,
  rp732,
  rp733,
  rp734,
  rp735,
  rp736,
  rp737,
  rp740,
  rp750,
  rp787,
  rp788,
  rp790,
};